import React, { useState } from 'react';
import PropTypes from 'prop-types';

export const EmailInputContext = React.createContext();

export const EmailInputProvider = ({ children }) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [acceptedMarketing, setAcceptedMarketing] = useState(false);
  const [email, setEmail] = useState('');
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  return (
    <EmailInputContext.Provider
      value={{
        firstName,
        setFirstName,
        lastName,
        setLastName,
        email,
        setEmail,
        acceptedMarketing,
        setAcceptedMarketing,
        acceptedTerms,
        setAcceptedTerms,
        buttonDisabled,
        setButtonDisabled,
      }}>
      {children}
    </EmailInputContext.Provider>
  );
};

EmailInputProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
